<template>
  <div class='EnbItem01'
  v-if="exibeSemEstoque"
  :style="{ 
    backgroundColor: Prefes.produto.corBackground,
    fontFamily: Prefes.produto.font,
    color: Prefes.produto.corFont,
    fontStyle: parseInt(Prefes.produto.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.produto.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.produto.textDecoration) ? 'underline' : '',
    fontSize: Prefes.produto.fontHeight + 'px'
  }"
  >
    <div class="cont-img">
      <div class="btn-action" v-if="Object.keys(Profile).length && Profile.tipo === 'a'">
        <edit-icon @click="edit"/>
        <edit-fast-icon @click="fastEdit"/>
        <delete-icon @click="del"/>
      </div>
      <enb-itemImg01 :data="data"/>
    </div>
    <div class="cont-desc">
      {{ data.name.length > 35 ? data.name.substr(0, 34) + '...' : data.name }}
    </div>
    <div class="cont-valor">
      <span :class="{ disabled: isString(data.oferta) > 0 }" style="margin: 5px">{{ data.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</span>
      <span v-if="isString(data.oferta) > 0" style="margin: 5px">{{ data.oferta.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</span>
    </div>
    <div class="cont-btn">
      <enb-itemBtn01 :data="data"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnbItemImg01 from './EnbItemImg01'
import EnbItemBtn01 from './EnbItemBtn01.vue'
import EditFastIcon from '@/components/EnbPainel/Icons/EditFastIcon'
import EditIcon from '@/components/EnbPainel/Icons/EditIcon'
import DeleteIcon from '@/components/EnbPainel/Icons/DeleteIcon'
export default {
  name: 'EnbItem01',
  components: { EnbItemImg01, EnbItemBtn01, EditFastIcon, EditIcon, DeleteIcon },
  computed: {
    ...mapGetters(['Profile', 'SelectedProds', 'Prefes']),
    exibeSemEstoque () {
      if(this.data.gerEstoque && this.data.tipo !== 'Variável') {
        if(this.data.exibeSemEstoque) {
          return true
        }
        else {
          return this.data.estoque > 0 
        }
      }
      else {
        return true
      }
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    ...mapActions(['PushProdEdit', 'ClearProdEdit', 'SetModal01', 'DeleteProd', 'SetModal']),
    edit () {
      this.ClearProdEdit()
        .then(() => this.PushProdEdit(this.data))
        .then(() => {
          this.$router.push('/painel/produtos/edit')
        })
    },
    fastEdit () {
      this.ClearProdEdit()
        .then(() => this.PushProdEdit(this.data))
        .then(() => {
          this.SetModal01({ component: 'FastProdEdit', active: true })
        })
    },
    del () {
      this.SetModal({ 
        component: 'AskAction',
        active: true,
        ask: 'Tem certeza que deseja excluir o produto?',
        action: 'DeleteProd',
        payload: [this.data]
      })
    },
    isString (value) {
      return typeof value === 'string' ? parseFloat(value.replace(/\./g, '').replace('R$ ', '').replace(',', '.')) : value
    }
  }
}
</script>

<style scoped>
.EnbItem01 {
  width: 200px;
  height: 330px;
  /* border: thin solid #CCCCCC; */
  border-radius: 5px;
  box-shadow: 0px 0px 5px 0.5px #CCCCCC;
  margin: 2%;
}

.cont-img {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 180px;
  position: relative;
}
.cont-desc {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cont-valor {
  width: 100%;
  height: 50px;
  font-weight: bold;
}
span {
  display: block;
}
.cont-btn {
  width: 100%;
  height: 50px;
}

.btn-action {
  display: flex;
  position: absolute;
  background-color: #FFFFFF;
}

.disabled {
  color: #CCCCCC;
  text-decoration: line-through;
}

@media (max-width: 500px) {
  .EnbItem01 {
    width: 45%;
  }
}
</style>
